import { useTranslation } from "react-i18next";
import type { IItemsListing } from "@app/dashboard/types/innerLayout/cards/items-list-box"
import styles from "./items-listing.module.scss";

export const ItemsListing = ({ localization, itemsList }: IItemsListing) => {
  const { t } = useTranslation();

  return (
    <div className={styles["items-listing"]}>
      {
        itemsList?.map((item, index) =>
          <div className={styles["items-listing__item"]} key={`list-box-item-${index}`}>

            {
              item.img &&
              <div className={styles["items-listing__item__img"]}>
                {
                  typeof item.img === 'string' ?
                    <img src={item.img} alt={item.name} />
                    :
                    item.img
                }
              </div>
            }

            {
              <div className={styles["items-listing__item__info"]}>

                {
                  item.name &&
                  <div className={styles["items-listing__item__info__name"]}>
                    {item.name}
                  </div>
                }
                {
                  item.category &&
                  <div className={styles["items-listing__item__info__category"]}>
                    {item.category}
                  </div>
                }
              </div>
            }

            {
              <div className={styles["items-listing__item__price-quantity-box"]}>

                {
                  item.price &&
                  <div className={styles["items-listing__item__price-quantity-box__price"]}>
                    {item.price}
                  </div>
                }
                {
                  item.quantity &&
                  <div className={styles["items-listing__item__price-quantity-box__quantity"]}>
                    {`${localization?.quantity || t('innerLayout.quantity')}: ${item.quantity}`}
                  </div>
                }
              </div>
            }

          </div>
        )
      }
    </div>
  )
}
